import { reduxKey } from '../../constants';
import { createAction } from 'redux-actions';

export const feedbackPageMounted = createAction(
  `${reduxKey}.FEEDBACK_LOADED`,
  () => ({})
);

export const feedbackPageReload = createAction(
  `${reduxKey}.FEEDBACK_RELOAD`,
  ({ dontClearUnseenIds = false }: { dontClearUnseenIds?: boolean }) => ({
    dontClearUnseenIds,
  })
);

export const feedbackPageReloaded = createAction(
  `${reduxKey}.FEEDBACK_RELOADED`,
  () => ({})
);
